var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02783 3.10986V20.5999C2.02781 20.8592 2.09502 21.1141 2.22292 21.3397C2.35081 21.5653 2.53501 21.7539 2.75755 21.8871C2.98008 22.0203 3.23334 22.0935 3.49261 22.0996C3.75187 22.1057 4.00829 22.0444 4.23683 21.9219L20.5598 13.1769C20.799 13.0487 20.9988 12.858 21.1382 12.6252C21.2775 12.3924 21.3511 12.1262 21.3511 11.8549C21.3511 11.5835 21.2775 11.3173 21.1382 11.0845C20.9988 10.8517 20.799 10.6611 20.5598 10.5329L4.23683 1.78786C4.00829 1.66528 3.75187 1.60405 3.49261 1.61014C3.23334 1.61623 2.98008 1.68944 2.75755 1.82261C2.53501 1.95579 2.35081 2.14439 2.22292 2.37C2.09502 2.59561 2.02781 2.85052 2.02783 3.10986V3.10986Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPlay;